// Inactivity timeout hook
// Logs out user after period of inactivity

import { useEffect, useRef, useCallback } from 'react';
import { windowSessionCoordinator } from '../services/windowSessionCoordinator';

export const useInactivityTimeout = (onTimeout, timeoutDuration = 30 * 60 * 1000) => {
  const timeoutRef = useRef(null);

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (typeof onTimeout !== 'function') {
      return;
    }
    timeoutRef.current = setTimeout(onTimeout, timeoutDuration);
  }, [onTimeout, timeoutDuration]);

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

    const handleActivity = () => {
      resetTimeout();
      windowSessionCoordinator.publishActivity();
    };

    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    const unsubscribeActivity = windowSessionCoordinator.subscribeActivity(() => {
      resetTimeout();
    });

    resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      unsubscribeActivity();
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [resetTimeout]);
};
